export const Categories = Object.freeze({
  Google: 'Google',
  FacebookCarousel: 'Carousel',
  FacebookFeatured: 'FeaturedProducts',
  FacebookReferral: 'Referral',
  FacebookImpression: 'Impression',
});

export default class Platform {
}
